"use strict";

window.Certifications.Pages.Nominations = createReactClass({
  propTypes() {},
  componentWillMount() {
    this.nominationsStore = Flux.Certifications.CertifierNominationsStore;
    return this.nominationsStore.initialize({}, this.forceUpdate, this);
  },
  componentWillUnmount() {
    return this.nominationsStore.cleanup(this.forceUpdate);
  },
  componentDidMount() {
    const maxNominations = this.nominationsStore.totalNominations();
    this.searchView = new Search.UserSearch({
      el: $("#search"),
      placeholder: "Search by name...",
      maximumSelectionSize: maxNominations,
      minimumInputLength: 1,
      limit: 3,
      formatSelectionTooBig(limit) {
        return "You can only nominate " + $h.numberAndNoun(maxNominations, "person");
      }
    });
    this.searchView.on("item-selected", this.addNominee, this);
    return this.searchView.on("item-removed", this.removeNominee, this);
  },
  addNominee(nominatedProfile) {
    return Flux.Dispatcher.dispatch({
      actionType: "certifier-nominate",
      nominatedProfile
    });
  },
  removeNominee(removedProfile) {
    return Flux.Dispatcher.dispatch({
      actionType: "certifier-remove-nomination",
      removedProfile
    });
  },
  render() {
    if (this.nominationsStore.hasData()) {
      return this.renderReady();
    } else {
      return this.renderLoading();
    }
  },
  renderLoading() {
    return /* @__PURE__ */React.createElement("div", {
      className: "DesignSystem"
    }, this.header(), this.nominationFinder(), /* @__PURE__ */React.createElement("label", null, " Loading... "));
  },
  renderReady() {
    $("#search").select2("data", this.nominationsStore.takenNominations());
    return /* @__PURE__ */React.createElement("div", {
      className: "DesignSystem"
    }, this.header(), this.nominationFinder(), this.nominationsList(), this.confirmButton());
  },
  header() {
    return /* @__PURE__ */React.createElement("div", {
      className: "u-fontSans"
    }, /* @__PURE__ */React.createElement("h1", {
      className: "u-tcGrayDarkest u-mb2x u-mt1x"
    }, "Welcome to the endorser program!"), /* @__PURE__ */React.createElement("h5", {
      className: "u-tcGrayDarkest u-mt1x u-mb8x"
    }, "Is there anyone you would  like to see recommendations from?"));
  },
  nominationsLeftCounter() {
    const nominationsLeft = this.nominationsStore.nominationsLeft();
    const text = "You have " + $h.numberAndNoun(nominationsLeft, "nomination") + " left";
    return /* @__PURE__ */React.createElement("label", {
      className: "u-tcBlue"
    }, " ", text, " ");
  },
  fetchingNominationsLeft() {
    return this.nominationsLeftCounter();
  },
  nominationFinder() {
    return /* @__PURE__ */React.createElement("div", {
      className: "Panel u-p8x"
    }, this.nominationsLeftCounter(), /* @__PURE__ */React.createElement("div", {
      className: "select2-no-default-pills"
    }, /* @__PURE__ */React.createElement("div", {
      id: "search",
      style: {
        width: "100%"
      }
    })));
  },
  nominationsList() {
    const views = _.map(this.nominationsStore.nominations(), nomination => {
      return this.nomineeView(nomination);
    });
    views.reverse();
    return /* @__PURE__ */React.createElement("div", null, views);
  },
  nomineeView(nomination) {
    const nominatedProfile = nomination.attributes;
    nominatedProfile.display_name = nominatedProfile.name;
    nominatedProfile.photo = nominatedProfile.profile_pic_url;
    return /* @__PURE__ */React.createElement("div", {
      className: "u-mt4x u-mb2x",
      key: nominatedProfile.id
    }, /* @__PURE__ */React.createElement("div", {
      className: "Panel u-p4x"
    }, this.profileWithDelete(nominatedProfile)));
  },
  profileWithDelete(profile) {
    const deleteHandler = () => {
      this.removeNominee(profile);
      const data = $("#search").select2("data");
      const newData = _.reject(data, entry => entry.id === profile.id);
      return $("#search").select2("data", newData);
    };
    return /* @__PURE__ */React.createElement("div", {
      className: "Media"
    }, /* @__PURE__ */React.createElement("div", {
      className: "Media--left Media--middle"
    }, /* @__PURE__ */React.createElement(Certifications.Components.CertifierProfilePreview, {
      certifier: profile
    })), /* @__PURE__ */React.createElement("div", {
      className: "Media--right Media--middle u-tcGray"
    }, /* @__PURE__ */React.createElement(Components.Buttons.Delete, {
      handler: deleteHandler
    })));
  },
  confirmButton() {
    const nextPage = $r.certifications_suggestions_path();
    let text = "I don't want to nominate endorsers";
    let buttonClasses = "u-tcGrayDark";
    if (this.nominationsStore.madeNominations()) {
      text = "Send Nominations";
      buttonClasses = "Button Button--block Button--green Button--xl";
    }
    const classes = "u-taCenter clickable u-mt4x " + buttonClasses;
    return /* @__PURE__ */React.createElement("label", {
      href: nextPage,
      className: classes,
      onClick: this.confirm
    }, text);
  },
  confirm() {
    return Flux.Dispatcher.dispatch({
      actionType: "certifier-nominations-confirm"
    });
  }
});